import { openBlock as e, createElementBlock as a, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M12 4.25A1.75 1.75 0 0 0 10.25 6v1.25H8A1.75 1.75 0 0 0 6.25 9v2c0 .088.015.172.043.25H4A1.75 1.75 0 0 0 2.25 13v8c0 .966.784 1.75 1.75 1.75h12A1.75 1.75 0 0 0 17.75 21v-6A1.75 1.75 0 0 0 16 13.25h-5.382a.25.25 0 0 1-.224-.138l-.447-.895a1.75 1.75 0 0 0-1.565-.967h-.675A.749.749 0 0 0 7.75 11V9A.25.25 0 0 1 8 8.75h3.483c.1 0 .19.06.23.152l.338.787a1.75 1.75 0 0 0 1.608 1.061H18a.25.25 0 0 1 .25.25v5a.75.75 0 0 0 1.5 0v-5A1.75 1.75 0 0 0 18 9.25h-4.34a.25.25 0 0 1-.23-.152l-.338-.787a1.75 1.75 0 0 0-1.342-1.04V6a.25.25 0 0 1 .25-.25h2.654a.25.25 0 0 1 .226.143l.171.36c.29.609.905.997 1.58.997H20a.25.25 0 0 1 .25.25V11a.75.75 0 0 0 1.5 0V7.5A1.75 1.75 0 0 0 20 5.75h-3.369a.25.25 0 0 1-.225-.143l-.172-.36a1.75 1.75 0 0 0-1.58-.997H12Zm-8 8.5a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h12a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25h-5.382a1.75 1.75 0 0 1-1.565-.967l-.447-.895a.25.25 0 0 0-.224-.138H4Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  o
];
function n(h, r) {
  return e(), a("svg", l, [...c]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
